/*
 * Accordion
 */
(function() {
    $A.on("load", function() {
        let availableAccordion = document.querySelectorAll('[data-whatsock-module="accordion"]');

        if (!("setAccordion" in $A)) {
            console.log('Accordion not set.');
        }
        else{
            console.log('Accordion Set w/ ', availableAccordion.length);
            render();
        }

        function render(){
            for (var i = availableAccordion.length - 1; i >= 0; i--) {

                let thisAccordion = availableAccordion[i];
                let accordionDC;
                let isActive = false;


                if(!thisAccordion.classList.contains('module-loaded')){
                    thisAccordion.classList.add('module-loaded');

                    let setAccordionlOptions = {
                        toggleHide: true,
                        singleTabStop: false,
                        isToggle: true,
                        afterRender: function(DC) {
                            let plusIcon = DC.trigger.querySelectorAll('.icon')[0];
                            plusIcon.classList.add('plus-open');
                        },
                        afterRemove: function(DC) {
                            let plusIcon = DC.trigger.querySelectorAll('.icon')[0];
                            plusIcon.classList.remove('plus-open');

                        }
                    };

                    accordionDC = $A.setAccordion(".accordion-trigger-"+availableAccordion[i].dataset.index, setAccordionlOptions );

                    console.log('Loaded! ', thisAccordion, availableAccordion[i].dataset.index, accordionDC);

                    isActive = true;
                }
            };

        }
    });
})();